import React from 'react';
import Information from './Information';
import OrderHistory from './OrderHistory';
import POHistory from './POHistory';
import CampaignHistory from './CampaignHistory';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';

const Content = ({
    product,
    orders,
    campaign,
    po,
    pagination,
    loadOrders,
    loadCampaign,
    loadPO,
    tabValue,
    handleTabs,
    changePage,
    printLabel,
    isMedical,
    inventory,
    inventoryFilter
}) => {

    return (
        <TabContext value={tabValue}>
            <TabList
                id="Product-Menu-card"
                className="Menu-tabs-viewpage"
                onChange={handleTabs}>
                <Tab label="Information" value="a" />
                <Tab label="Order History" value="b" onClick={loadOrders} />
                <Tab label="PO History" value="c" onClick={loadPO} />
                {isMedical ? <Tab label="Campaign History" value="d" onClick={loadCampaign} /> : ""}
            </TabList>
            <TabPanel value="a" label="Information" >
                <Information product={product} printLabel={printLabel} isMedical={isMedical} inventory={inventory} inventoryFilter={inventoryFilter} />
            </TabPanel>
            <TabPanel value="b" label="Order History">
                <OrderHistory orders={orders} pagination={pagination.orders} changePage={changePage} />
            </TabPanel>
            <TabPanel value="c" label="PO History">
                <POHistory po={po} pagination={pagination.po} changePage={changePage} />
            </TabPanel>
            {
                isMedical ?
                    <TabPanel value="d" label="Campaign History">
                        <CampaignHistory campaign={campaign} pagination={pagination.campaign} changePage={changePage} />
                    </TabPanel>
                    :

                    ""
            }
        </TabContext>
    )
}

export default Content;
